import { ERROR_MSG, GAME_STATES } from "./constants";
import { gameData, networkData, demoState } from "./data";
import { clickFlag, pulsateNumbers, revealPreviousFlags } from "./flags";
import GameService from "./gameService";
import { banderitasCollection, gameAssets, showErrorPopup, shownNetworkErrorPopup, showManualPopup, ShowInsufficientBalancePopup, setupNumOfBet, setupFTUE, setupNumOfGames, resetFtuePanel, resetTutorial, setSessionExpired } from "./gameUI";
import { balanceFn, changePlayButtonStateAndText, formatBalance, getNumbersOccurringTwice, makeInitialSetupDisable, processResult, scaleBalance, setBalance, setInitialBalance, setUserName, showJackpotPanel } from "./gameLogic";
import { generateClientSeed } from "../../../utils/common.helper";
import { gameStates } from "../../jeepneyGo/core/gameStates";
import { playPlay } from "./soundManager";
import { setPumpIdleAnimation } from "./pump";
import { setupTutorial } from "./popups/tutorial";
import { setActiveLanguage } from "./popups/settings";
import { showGrandWin, showMajorWin, showMinorWin } from "./jackpotPanel";
import { populateRows } from "./popups/betHistory";

export let serviceInitSuccess = false
let isPlaceBetValid = true

export const winningAmount = () => networkData?.dataScratchScore?.winningAmount
export const balance = () => networkData?.dataScratchScore?.wallet?.balance
export const pattern = () => networkData?.dataScratchScore?.mangoesValue
export const baseScore = () => networkData?.dataScratchScore?.gameResult?.baseScore ?? networkData?.dataScratchScore?.baseScore
export const pumpMultiplier = () => networkData?.dataScratchScore?.gameResult?.multiplier
export const typeOfWin = () => networkData?.dataScratchScore?.gameResult?.typeOfWin
export const betAmount = () => gameData?.betAmount
export const remainingTickets = () => networkData?.dataLastPendingBet?.ticketDetails?.remainingTicket
export const userName = () => networkData?.dataWithJwt?.user?.userName
export const initialBalance = () => networkData?.dataWithJwt?.wallet?.balance
// export const jackpotDetails = () => 


const serviceInit = async () => {
    gameData.gameState = GAME_STATES.API_FETCHING
    if (demoState.isDemo) {
        gameData.gameState = GAME_STATES.IDLE
        gameAssets.balanceAmount.text = formatBalance(gameData.balance)
        scaleBalance()
        networkData.betArray = gameData.demoBetValues;
        networkData.roundArray = gameData.demoGamesValues;
        networkData.gamePoint = networkData.roundArray.length - 1;
        networkData.betPoint = networkData.betArray.length - 1
        gameAssets.textOfBets.text = networkData.betArray[networkData.betPoint]
        gameAssets.textOfGames.text = networkData.roundArray[networkData.gamePoint].replace(/\sGames?$/, '');
        gameData.betAmount = gameAssets.textOfBets.text
        gameData.numberOfGames = gameAssets.textOfGames.text
        setupNumOfBet()
        setupNumOfGames()
        changePlayButtonStateAndText(gameAssets.playButtonNormal)
        setupTutorial()
        resetTutorial()
        return;
    }

    getAndStoreJwtToken()
        .then(() => {
            serviceInitSuccess = true
        })
        .then(getLastPendingBet)
        .catch((error) => {
            shownNetworkErrorPopup()
            // console.error("Error during service initialization:", error);
        });
}

const getAndStoreOperatorToken = async () => {
    const { currencyCode, userCode } = networkData || {}

    if (!currencyCode || !userCode) {
        return Promise.reject(new Error(
            `Missing required fields: currencyCode: ${currencyCode}, userCode: ${userCode}`
        ))
    }

    const accessTokenData = {
        currencyCode: currencyCode,
        userCode: userCode,
    }

    gameData.gameState = GAME_STATES.API_FETCHING

    return GameService.getOperatorUserToken(accessTokenData)
        .then((tokenData) => {
            storeToken(tokenData)
            return tokenData
        })
        .catch((error) => {
            return Promise.reject(new Error('Error getting operator access token: ' + error.message))
        });
}

const storeToken = (tokenData) => networkData.operatorUserToken = tokenData.accessToken

const getAndStoreJwtToken = async () => {
    const { operatorUserToken, currencyCode, operatorId, gameId } = networkData || {}

    if (!operatorUserToken || !operatorId || !gameId || !currencyCode) {
        return Promise.reject(new Error(
            `Missing required fields for JWT token: operatorUserToken: ${operatorUserToken}, operatorId: ${operatorId}, gameId: ${gameId}, currencyCode: ${currencyCode}`
        ))
    }

    const dataJwt = {
        operatorUserToken,
        operatorId,
        gameId,
        currencyCode,
    };

    gameData.gameState = GAME_STATES.API_FETCHING

    return GameService.getAccessToken(dataJwt)
        .then((tokenData) => {
            if (!networkData.jwtToken) storeJwtToken(tokenData)
            storeDataWithJwt(tokenData)
            authorize()
            setUserName()
            setInitialBalance()
            saveVaildBetArray(tokenData?.data?.gameSettings?.validBetArray)
            saveValidRoundArray(tokenData?.data?.gameSettings?.numberOfRounds)
            networkData.ticketError = false;
            networkData.isJackpot = tokenData?.data?.gameSettings?.isJackpotActive;
            if (tokenData?.data?.gameSettings?.jackpotDetails?.JackpotTiers) {
                networkData.grandCurrentJackpotValue = tokenData?.data?.gameSettings?.jackpotDetails?.JackpotTiers[2].currentValue
                networkData.majorCurrentJackpotValue = tokenData?.data?.gameSettings?.jackpotDetails?.JackpotTiers[0].currentValue
                networkData.minorCurrentJackpotValue = tokenData?.data?.gameSettings?.jackpotDetails?.JackpotTiers[1].currentValue
            }
            networkData.betPoint = networkData?.betArray?.length - 1
            gameAssets.textOfBets.text = networkData?.betArray[networkData.betPoint]
            gameData.betAmount = networkData?.betArray[networkData.betPoint]
            gameData.gameLanguage = tokenData?.data?.user?.language
            gameAssets.totalBetAmount.text = gameData.numberOfGames * gameData.betAmount
            if (!gameData.gameLanguage) {
                setupFTUE()
                resetFtuePanel()
                makeInitialSetupDisable(true)
            } else {
                setupTutorial(gameData.gameLanguage)
                setActiveLanguage(gameData.gameLanguage)
                if (networkData.isJackpot) {
                    showJackpotPanel()
                    // resetFlagAndPumpPosition()
                }
            }
            resetTutorial()
            return tokenData;
        })
        .catch((error) => {
            networkData.ticketError = true;
            console.log("fwefwefwefwefwefewf", error);

            showManualPopup("Network Error")
            return
            // return Promise.reject(new Error('Error getting JWT token: ' + error.message));
        });
}

export const setLang = async (language, flag = false) => {
    if (demoState.isDemo) {
        setupTutorial(language)
        resetTutorial()
        return;
    }
    GameService.setLanguage(language)
        .then(() => {
            if (flag) {
                setupTutorial(gameData.gameLanguage)
                resetTutorial()
                setActiveLanguage(gameData.gameLanguage)
            }
            console.log("language set successfully");
            return;
        })
        .catch((error) => {
            // showManualPopup("Network Error")
            setupTutorial('en')
            resetTutorial()
            setActiveLanguage('en')
            return;
        })
}

const saveVaildBetArray = (betArray) => {
    networkData.betArray = betArray
    networkData?.betArray?.sort((a, b) => b - a);
    setupNumOfBet();
}

const saveValidRoundArray = (roundArray) => {
    const sortedRounds = [...roundArray].sort((a, b) => b - a);

    networkData.gamePoint = sortedRounds.length - 1;
    gameAssets.textOfGames.text = sortedRounds[networkData.gamePoint]
    gameData.numberOfGames = sortedRounds[networkData.gamePoint]

    networkData.roundArray = sortedRounds.map(num => {
        const label = num === 1 ? 'Game' : 'Games';
        return `${num} ${label}`;
    });

    setupNumOfGames();
}

const storeJwtToken = (tokenData) => {
    networkData.jwtToken = tokenData.data.accessToken
}

const storeDataWithJwt = (tokenData) => {
    networkData.dataWithJwt = tokenData.data
    networkData.userId = tokenData?.data?.user?.id
}

const authorize = () => GameService.authorize()

const hasTicketDetails = (data) => Object.keys(data?.data?.ticketDetails ?? {}).length > 0
const hasBet = (data) => Object.keys(data?.data?.bet ?? {}).length > 0
const hasNoBet = data => !hasBet(data)

const shouldPlaceBet = data => hasTicketDetails(data) && hasNoBet(data)
const previousBetNotCompleted = data => {
    return hasTicketDetails(data) && hasBet(data)
}

export const getLastPendingBet = async () => {    
    if (demoState.isDemo) {
       
        if (gameData.ticketsRemaining) {
            networkData.dataPlaceBet = false;
            changePlayButtonStateAndText(gameAssets.playButtonAtPlay, true);
            gameAssets.balanceAmount.text = formatBalance(gameData.balance);
            scaleBalance()
            if (networkData.allFlagValues.length === 0) scratchScoreDemo();
            networkData.dataPlaceBet = true;
            return new Promise((resolve) => {
                setTimeout(resolve, 900);
            });
        } else {
            networkData.dataPlaceBet = false;
            gameAssets.playButtonAtPlay.visible = false
            changePlayButtonStateAndText(gameAssets.playButtonNormal)
            gameAssets.balanceAmount.text = formatBalance(gameData.balance);
            scaleBalance()
            return Promise.resolve();
        }
    }
    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return
    }

    gameData.gameState = GAME_STATES.API_FETCHING
    return GameService.getLastPendingBet()
        .then((data) => {
            networkData.ticketError = false;
            if (Object.keys(data.data).length === 0) {
                networkData.dataPlaceBet = false;
                gameAssets.playButtonAtPlay.visible = false
                gameAssets.autoPlayHitGraphic.interactive = true;
                gameAssets.turboPlayHitGraphic.interactive = true;
                changePlayButtonStateAndText(gameAssets.playButtonNormal)
                networkData.buyTickets = null;
            } else {
                storeDataWithLastPendingBet(data)
                networkData.dataPlaceBet = true;
                networkData.buyTickets = data;
                changePlayButtonStateAndText(gameAssets.playButtonAtPlay, true)
            }


            return data
        }).then((data) => {
            gameData.scratchIndex = [];
            if (shouldPlaceBet(data)) {
                return placeBet().then(() => data);
            }
            return data
        })
        .then((data) => {
            if (previousBetNotCompleted(data)) {
                gameData.scratchIndex = data.data.bet.scratchedScoresIndexes;
                gameData.scratchedValues = data?.data?.bet?.scratchedScores;
                revealPreviousFlags(
                    data.data.bet.scratchedScoresIndexes,
                    data.data.bet.scratchedScores
                )

                const numArray = getNumbersOccurringTwice(gameData.scratchedValues)
                if (numArray.length) {
                    numArray.forEach((item) => {
                        pulsateNumbers(item)
                    })
                }
            }
            gameData.gameState = GAME_STATES.IDLE
        })
        .catch((error) => {
            networkData.ticketError = true
            if (error?.response?.data?.errors[0]?.name == 'InvalidToken' || error?.response?.data?.errors[0]?.fields?.message == 'jwt expired') {
                showManualPopup('Invalid Token!');
                return;
            }
            showManualPopup("Network Error")

            // return Promise.reject(new Error('Error place bet: ' + error.message))
        })
}

const buyTicketOrPlaceBet = (data) => {

    if (data?.data) {
        if (Object.keys(data.data).length === 0) buyTickets()
    }

    // console.log(shouldPlaceBet(data))
    if (shouldPlaceBet(data)) placeBet()
}

const checkValidBalance = () => {
    if (gameData.numberOfGames * gameData.betAmount > gameData.balance) {
        ShowInsufficientBalancePopup();
        networkData.insufficientAmount = true
        networkData.ticketError = true;
        return false
    } else {
        return true;
    }
}

export const buyTickets = () => {
    if (demoState.isDemo) {
        if (checkValidBalance()) {
            networkData.ticketError = false;
            changePlayButtonStateAndText(gameAssets.playButtonAtPlay, true)
            gameData.balance = gameData.balance - gameData.numberOfGames * gameData.betAmount
            gameAssets.balanceAmount.text = formatBalance(gameData.balance)
            scaleBalance()

            gameData.ticketsRemaining = true;
            networkData.dataPlaceBet = true
            if (networkData.allFlagValues.length === 0) scratchScoreDemo();
        }
        return
    }
    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return
    }

    const ticketData = {
        // "clientSeed": "SAVZVGHSD1@gf12b32",
        "clientSeed": generateClientSeed()?.seed,
        "betAmount": gameData.betAmount,
        "ticketCount": gameData.numberOfGames
    }

    gameData.gameState = GAME_STATES.API_FETCHING
    networkData.ticketDetails = null;
    networkData.dataPlaceBet = false;

    return GameService.buyTickets(ticketData)
        .then(async (data) => {
            storeDataWithBuyTickets(data)
            // getLastPendingBet()
            networkData.ticketError = false;
            await placeBet()
            playPlay(true)

            return data;
        })
        .catch(async (error) => {
            gameData.gameState = gameStates.IDLE;
            networkData.ticketError = true;
            gameAssets.autoPlaySelected.visible = false;
            gameAssets.turboPlaySelected.visible = false;
            
            if(error?.response?.data?.errors[0]?.description === "USER_IS_BLOCKED"){
                showManualPopup("USER BLOCKED")
                return
            }
           else if (
                error?.response?.data.errors[0].description === "INSUFFICIENT_FUNDS"
            ) {
                ShowInsufficientBalancePopup();
                networkData.insufficientAmount = true
                return
            } else if (
                error?.response?.data.errors[0].description ===
                "Invalid or no tickets available."
            ) {
                showManualPopup("Tickets unavailable");
                return;
            } else if (error?.response?.data?.errors[0]?.errorCode == 3008 || error?.response?.data?.errors[0]?.description === 'INVALID_TOKEN') {
                showManualPopup("Token Expired");
                setTimeout(()=>{
                    setSessionExpired()
                }, 1200)
                return;
            }
            //    else if(error?.response?.data?.errors[0]?.description == "valid ")
            if (error?.response?.data?.errors[0].errorCode == 3005) {
                showManualPopup("Token Expired!");

                setTimeout(()=>{
                    setSessionExpired()
                }, 1200)
                return;
            } else if (error?.response?.data?.errors[0]?.description == 'valid tickets remaining') {
                showManualPopup('Tickets Remaining');
                return;
            }
            showManualPopup("Network Error");

            // return Promise.reject(new Error('Error place bet: ' + error.message));
        })

}

function handleJackpotPanel(jackpotDetails) {
    networkData.jackpot = true;
    networkData.grandCurrentJackpotValue = jackpotDetails[2]?.data?.currentValue
    networkData.majorCurrentJackpotValue = jackpotDetails[0]?.data?.currentValue
    networkData.minorCurrentJackpotValue = jackpotDetails[1]?.data?.currentValue

    networkData.resetGrandJackpotValue = jackpotDetails[2]?.data?.jackpotBeforeTrigger
    networkData.resetMajorJackpotValue = jackpotDetails[0]?.data?.jackpotBeforeTrigger
    networkData.resetMinorJackpotValue = jackpotDetails[1]?.data?.jackpotBeforeTrigger

    showGrandWin(networkData.jackpotGrandWin ? networkData.jackpotGrandWinAmount : networkData.grandCurrentJackpotValue, 4)
    showMajorWin(networkData.jackpotMajorWin ? networkData.jackpotMajorWinAmount : networkData.majorCurrentJackpotValue, 4)
    showMinorWin(networkData.jackpotMinorWin ? networkData.jackpotMinorWinAmount : networkData.minorCurrentJackpotValue, 4)
}

const storeDataWithBuyTickets = (data) => {
    networkData.buyTickets = data.data
    gameAssets.balanceAmount.text = formatBalance(data?.data?.wallet?.balance)
    scaleBalance()

    if (networkData.buyTickets.details && gameAssets?.ticketsNumber) {
        // gameAssets.textOfGames.text = gameData.numberOfGames = networkData.buyTickets.details.ticketCount;
        networkData.ticketDetails = networkData.buyTickets.details
        networkData.insufficientAmount = false;
    }

    if (networkData?.buyTickets?.wallet && gameAssets?.balanceText?.text) {
        balanceFn(networkData.buyTickets.wallet.balance)
    }

}
let temp = [];
const handelJackpotDetails = (jackpotDetails) => {
    networkData.jackpotMinorWin = jackpotDetails[1]?.data.won
    networkData.jackpotMajorWin = jackpotDetails[0]?.data.won
    networkData.jackpotGrandWin = jackpotDetails[2]?.data.won

    if (networkData.jackpotMinorWin) networkData.lastJackpot = 'minor';
    if (networkData.jackpotMajorWin) networkData.lastJackpot = 'major';
    if (networkData.jackpotGrandWin) networkData.lastJackpot = 'grand';

    networkData.jackpotMinorWinAmount = jackpotDetails[1]?.data?.wonAmount
    networkData.jackpotMajorWinAmount = jackpotDetails[0]?.data?.wonAmount
    networkData.jackpotGrandWinAmount = jackpotDetails[2]?.data?.wonAmount
}

const storeDataWithLastPendingBet = (data) => {
    networkData.dataLastPendingBet = data.data

    if (hasTicketDetails(data) && gameAssets?.ticketsNumber) {
        gameAssets.textOfGames.text = gameData.numberOfGames = data.data.ticketDetails.ticketPurchased
        gameAssets.totalBetAmount.text = data.data.ticketDetails.betAmount
        networkData.ticketDetails = data.data.ticketDetails;
    }

    networkData.allFlagValues = data?.data?.bet?.scores
    if (networkData?.allFlagValues?.length > 0) {
        gameAssets.autoPlayHitGraphic.interactive = true;
        gameAssets.turboPlayHitGraphic.interactive = true;
    }
    gameAssets.textOfBets.text = data?.data?.ticketDetails?.singleBetAmount
    networkData.ticketsLeft = data?.data?.ticketDetails?.remainingTicket;
    networkData.currentTicket = data?.data?.ticketDetails?.currentTicket
    networkData.ticketsPurchased = gameAssets.textOfGames.text = data?.data?.ticketDetails?.ticketPurchased;
    gameData.betAmount = data?.data?.ticketDetails?.singleBetAmount;
    networkData.gamePoint = networkData?.roundArray?.findIndex(text => text.split(" ")[0] === networkData.ticketsPurchased.toString());
    networkData.betPoint = networkData?.betArray.findIndex(
        text => text == data?.data?.ticketDetails?.singleBetAmount
    );
    if (data?.data?.ticketDetails?.jackpotDetails.length > 0) {
        //   handelJackpotDetails(data?.data?.ticketDetails?.jackpotDetails);
        handleJackpot(data?.data?.ticketDetails?.jackpotDetails);
    }
}
const handleJackpot = (jackpotDetails) => {
    networkData.jackpot = true;
    networkData.jackpotMinorWin = gameData.minorFlag = jackpotDetails[1]?.transactionType == 'win' ? 1 : 0
    networkData.jackpotMajorWin = gameData.majorFlag = jackpotDetails[0]?.transactionType == 'win' ? 1 : 0
    networkData.jackpotGrandWin = gameData.grandFlag = jackpotDetails[2]?.transactionType == 'win' ? 1 : 0

    if (networkData.jackpotMinorWin) networkData.lastJackpot = 'minor';
    if (networkData.jackpotMajorWin) networkData.lastJackpot = 'major';
    if (networkData.jackpotGrandWin) networkData.lastJackpot = 'grand';

    networkData.resetMinorJackpotValue = jackpotDetails[1]?.jackpotBeforeTrigger;
    networkData.resetMajorJackpotValue = jackpotDetails[0]?.jackpotBeforeTrigger;
    networkData.resetGrandJackpotValue = jackpotDetails[2]?.jackpotBeforeTrigger;

    networkData.grandCurrentJackpotValue = jackpotDetails[2]?.currentValue;
    networkData.majorCurrentJackpotValue = jackpotDetails[0]?.currentValue;
    networkData.minorCurrentJackpotValue = jackpotDetails[1]?.currentValue;

    networkData.jackpotMinorWinAmount = jackpotDetails[1]?.amount
    networkData.jackpotMajorWinAmount = jackpotDetails[0]?.amount
    networkData.jackpotGrandWinAmount = jackpotDetails[2]?.amount

    if (networkData.jackpotMinorWin) {
        showMinorWin(networkData.jackpotMinorWinAmount, 4);
    }

    if (networkData.jackpotMajorWin) {
        showMajorWin(networkData.jackpotMajorWinAmount, 4);
    }

    if (networkData.jackpotGrandWin) {
        showGrandWin(networkData.jackpotGrandWinAmount, 4)
    }
}

export const placeBet = async () => {
    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return
    }

    const { clientSeed } = networkData || {}
    const { betAmount } = gameData || {}

    if (!clientSeed || !betAmount) {
        shownNetworkErrorPopup()
        // console.error(`Missing required bet data: clientSeed:${clientSeed} or betAmount:${betAmount}`)
        return
    }

    const betData = {
        clientSeed,
        betAmount
    }

    gameData.gameState = GAME_STATES.API_FETCHING
    return GameService.placeBet(betData)
        .then((placeBetData) => {
            storeDataWithPlaceBet(placeBetData)
            changePlayButtonStateAndText(gameAssets.playButtonAtPlay, true)
            gameAssets.autoPlayHitGraphic.interactive = true;
            gameAssets.turboPlayHitGraphic.interactive = true;
            return placeBetData;
        })
        .catch((error) => {
            networkData.dataPlaceBet = null;
            if (error.response.data.errors[0].description === 'Invalid or no tickets available.') {
                showManualPopup("Tickets unavailable")
                return
            }

            if (error?.response?.data?.errors[0]?.description === ERROR_MSG.PREVIOUS_BET_NOT_COMPLETED) {
                showManualPopup(ERROR_MSG.PREVIOUS_BET_NOT_COMPLETED)
                return
            }

            // buyTickets()
            // return Promise.reject(new Error('Error place bet: ' + error.message));
        })
}

export const betHistory = () => {
    if (demoState.isDemo) {
        return [];
    }

    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return []
    };

    return GameService.history()
        .then((data) => {
            const tempArray = data?.data?.rows?.map(({ bet_amount, createdat, result, winning_amount, beforebalance, afterbalance, scores, multiplier }) => {
                const dateObj = new Date(createdat);

                const date = dateObj.toLocaleDateString('en-CA');
                const time = dateObj.toLocaleTimeString('en-GB');

                return {
                    bet_amount,
                    result,
                    date,
                    time,
                    winning_amount,
                    beforebalance,
                    afterbalance,
                    scores,
                    multiplier
                };
            });

            console.log("RESPONSE BET HISTORY", tempArray);
            networkData.betHist = tempArray;
            if (tempArray.length) populateRows()

        }).catch((error) => {

            if (error?.response?.data?.errors[0]?.message == 'jwt expired') {
                showManualPopup("Token Expired!");
                return;
            }

            if (error?.response?.data?.errors[0]?.description == "Either access token not passed or it is expired") {
                showManualPopup("Token Expired!");
                return;
            }
        })
}

export const turbo = () => {
    if (demoState.isDemo) {
        networkData.turboData = true
        if (gameData.winGame) networkData.scratchResult = 'won'
        else networkData.scratchResult = 'lost'
        return
    }
    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return
    };

    gameData.gameState = GAME_STATES.API_FETCHING;
    networkData.turboData = false;
    return GameService.turboMode().then((data) => {
        networkData.turboData = true;
        networkData.ticketError = false;
        storeDataWithTurboMode(data);
    }).catch(async (error) => {
        networkData.turboData = false;
        if (error?.response?.data?.errors[0]?.description == "Either access token not passed or it is expired") {
            showManualPopup("Token Expired!");
            return;
        }

        if (error?.response?.data?.errors[0]?.message == 'jwt expired') {
            showManualPopup("Token Expired!");
            return;
        }

        shownNetworkErrorPopup();
    })
}

const storeDataWithTurboMode = (scoreData) => {
    const lastValidEntry = [...scoreData.data]
        .reverse()
        .find(entry => entry.gameResult);

    if (lastValidEntry) {
        const lastValidGameResult = lastValidEntry.gameResult;
        const winningAmount = lastValidEntry.winningAmount ?? 0;
        const updatedBalance = lastValidEntry?.wallet?.balance


        networkData.dataScratchScore = lastValidGameResult;
        networkData.scratchResult = lastValidGameResult.result;
        networkData.winType = lastValidGameResult.typeOfWin;
        networkData.winAmount = winningAmount;

        if (updatedBalance) {
            gameAssets.balanceAmount.text = formatBalance(updatedBalance);
            scaleBalance()
        }

    } else {
        // console.warn("No valid gameResult found in score data");
    }

}
const storeDataWithPlaceBet = (placeBetData) => {
    networkData.dataPlaceBet = true;
    networkData.allFlagValues = placeBetData?.data?.details?.scores
    gameData.scratchIndex = [];
    gameData.scratchedValues = [];
    gameAssets.totalBetAmount.text = placeBetData?.data?.details?.betAmount;
    networkData.ticketsPurchased = placeBetData?.data?.details?.ticketPurchased;
    // networkData.ticketsLeft = placeBetData?.data?.details?.ticketsLeft;
    networkData.currentTicket = placeBetData?.data?.details?.currentTicket
    gameData.gameState = GAME_STATES.IDLE;

    // if (placeBetData?.data?.details?.jackpotDetails.length > 0){
    //     handelJackpotDetails(placeBetData?.data?.details?.jackpotDetails);
    //     handleJackpotPanel(placeBetData?.data?.details?.jackpotDetails)
    // }
    // gameAssets.textOfGames.text = gameData.numberOfGames = placeBetData.data.details.ticketPurchased;
    // gameAssets.balanceText.text = placeBetData.data.wallet.balance
    // console.log("placeBetData", networkData.dataPlaceBet)
}
let selectedCounts = {};
export let tempArray = []

export const scratchScore = async (scoreIndex) => {

    if (demoState.isDemo) {

        const randomIndex = Math.floor(Math.random() * tempArray.length);
        const selectedValue = tempArray[randomIndex];

        gameData.scratchedValues.push(selectedValue);
        gameData.scratchIndex.push(scoreIndex);

        if (gameData.scratchedValues.length === 9 && !gameData.winGame) {
            networkData.scratchResult = 'lost'
        } else if (gameData.scratchedValues.filter(num => num === gameData.winNumber).length === 3) {
            networkData.scratchResult = 'won';
        }
        tempArray.splice(randomIndex, 1);
        processResult()
        return selectedValue;
    }

    if (!serviceInitSuccess) {
        shownNetworkErrorPopup()
        // console.error("Network service initialization failed")
        return
    }

    if (scoreIndex === undefined || scoreIndex === null) {
        shownNetworkErrorPopup()
        // console.error(`Missing required scratch score: scoreIndex:${scoreIndex}`)
        return
    }

    if (scoreIndex < 0 || scoreIndex > 8) {
        shownNetworkErrorPopup()
        // console.error(`ScoreIndex out of limit: scoreIndex:${scoreIndex}`)
        return
    }

    const scoreIndexData = {
        scoreIndex
    }

    if (!networkData.dataPlaceBet) {
        return;
    }

    return GameService.scratchScore(scoreIndexData)
        .then((scoreData) => {
            storeDataWithScratchScore(scoreData)
            setBalance()
            processResult()
            networkData.ticketError = false;
            // setWinnings()
            if (scoreData.data.gameResult.result !== "pending") {
                networkData.dataPlaceBet = false;
            }
            return scoreData;
        })
        .catch((error) => {
            const errorDescription = error?.response?.data?.errors[0]?.description;
            gameData.gameState = GAME_STATES.IDLE;

            setTimeout(() => {
                setPumpIdleAnimation(gameData?.scratchDoneNumber)
            }, 1000)

            if (errorDescription === ERROR_MSG.NO_PLACED_BET_FOUND) {
                if (!isPlaceBetValid) {
                    // console.error("Calling place bet again and again")
                    shownNetworkErrorPopup()
                    return
                }

                isPlaceBetValid = false;
                placeBetAndContinueFlagAnim(scoreIndexData);
            }

            if (errorDescription === ERROR_MSG.SCORE_ALREADY_SCRATCHED) {
                showErrorPopup("ALREADY\nSCRATCHED")
                return
            }

            if (error?.response?.data?.errors[0]?.fields?.message == 'jwt expired' || error?.response?.data?.errors[0]?.name == 'InvalidToken') {
                showManualPopup("Token Expired");

                setTimeout(()=>{
                    setSessionExpired()
                }, 1200)
                return;
            }

            // console.error("Error Message:", errorDescription);
            showManualPopup("Network Error");


            //   return Promise.reject(new Error(`Error Scratch Score: ${error.message}`));
        });

}

const scratchScoreDemo = () => {
    if (gameData.winGame === null) {
        gameData.winGame = Math.round(Math.random());
    }

    if (gameData.winGame === 0) {
        tempArray = [];
        temp.length = 0;
        selectedCounts = {}

        while (temp.length < 9) {
            let randomNumber = gameData.flagValues[Math.floor(Math.random() * gameData.flagValues.length)];


            if ((selectedCounts[randomNumber] || 0) < 2) {
                temp.push(randomNumber);
                selectedCounts[randomNumber] = (selectedCounts[randomNumber] || 0) + 1;
            }
        }

        temp.forEach((item) => {
            networkData.allFlagValues.push(item);
            tempArray.push(item);
        })

    } else {

        temp.length = 0;
        selectedCounts = {};
        tempArray = [];

        let threeTimesNumber = gameData.flagValues[Math.floor(Math.random() * gameData.flagValues.length)];
        selectedCounts[threeTimesNumber] = 3;

        temp.push(threeTimesNumber, threeTimesNumber, threeTimesNumber);
        gameData.winNumber = threeTimesNumber

        while (temp.length < 9) {
            let randomNumber = gameData.flagValues[Math.floor(Math.random() * gameData.flagValues.length)];

            if (!selectedCounts[randomNumber]) {
                temp.push(randomNumber);
                selectedCounts[randomNumber] = 1;
            }
        }


        for (let i = temp.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            [temp[i], temp[j]] = [temp[j], temp[i]];
        }

        temp.forEach((item) => {
            networkData.allFlagValues.push(item);
            tempArray.push(item);
        })
    }
};

const placeBetAndContinueFlagAnim = async (scoreIndexData) => {
    await placeBet()
    clickFlag(banderitasCollection[scoreIndexData.scoreIndex])
    isPlaceBetValid = true
}

const storeDataWithScratchScore = (scoreData) => {
    networkData.scratchResult = scoreData?.data?.gameResult.result
    gameData.scratchIndex = [];
    gameData.scratchIndex = scoreData.data.gameResult.scratchedScoresIndexes;
    gameData.scratchedValues.push(scoreData.data.gameResult.scratchedValue);
    networkData.dataScratchScore = null;
    networkData.dataScratchScore = scoreData.data
    networkData.winType = scoreData?.data?.gameResult?.typeOfWin
    if (networkData.scratchResult !== 'lost') networkData.winAmount = networkData.dataScratchScore.winningAmount;
    console.log("Fromherethe data gets store", networkData.dataScratchScore);
}

export async function isOnline(timeout = 3000) {
    if (demoState.isDemo) return true;
    if (!navigator.onLine) return false; // First, check browser's built-in online status

    // const loaderTimeout = setTimeout(() => {
    //     instances.NetworkLoader?.showLoader();
    // }, 750);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(process.env.REACT_APP_HEALTH_CHECK_API + '/health-check', {
            method: "GET",
            cache: "no-store",
            signal: controller.signal, // Attach the timeout
        });
        clearTimeout(timeoutId);
        return response.ok;
    } catch (error) {
        clearTimeout(timeoutId);
        return false; // If fetch fails or times out, assume offline
    }
    // return true
}

export default serviceInit
